'use strict';

import { Entity } from '../Entity';
import { GlobPlans } from './GlobPlans';

export class GlobPlansDisruption extends Entity {
  protected id;

  protected oldContract;

  protected oldPlanId;

  protected newContract;

  protected newPlanId;

  protected disruptionType;

  protected degradedService;

  protected year;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.oldContract = data.oldContract;

    this.newContract = data.newContract;

    this.disruptionType = data.disruptionType;

    this.degradedService = data.degradedService;

    this.year = data.year;

    if (data.oldPlanId) {
      const oldPlanId = new GlobPlans();

      oldPlanId.hydrate(data.oldPlanId);

      this.oldPlanId = oldPlanId;
    }

    if (data.newPlanId) {
      const newPlanId = new GlobPlans();

      newPlanId.hydrate(data.newPlanId);

      this.newPlanId = newPlanId;
    }
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getOldContract() {
    return this.oldContract;
  }

  public setOldContract(oldContract) {
    this.oldContract = oldContract;

    return this;
  }

  public getOldPlanId() {
    return this.oldPlanId;
  }

  public setOldPlanId(oldPlanId) {
    this.oldPlanId = oldPlanId;

    return this;
  }

  public getNewContract() {
    return this.newContract;
  }

  public setNewContract(newContract) {
    this.newContract = newContract;

    return this;
  }

  public getNewPlanId() {
    return this.newPlanId;
  }

  public setNewPlanId(newPlanId) {
    this.newPlanId = newPlanId;

    return this;
  }

  public getDisruptionType() {
    return this.disruptionType;
  }

  public setDisruptionType(disruptionType) {
    this.disruptionType = disruptionType;

    return this;
  }

  public getDegradedService() {
    return this.degradedService;
  }

  public setDegradedService(degradedService) {
    this.degradedService = degradedService;

    return this;
  }

  public getYear() {
    return this.year;
  }

  public setYear(year) {
    this.year = year;

    return this;
  }
}
